import React, { useState, useEffect } from "react";
import Banner from "./components/Banner";
import Storage from "./components/Storage";
import Upload from "./components/Upload";
import EditProfile from "./components/EditProfile";
import api from "services/api";

const ProfileOverview = () => {
  const [session, setSession] = useState(null);
  const [storage, setStorage] = useState(null);
  const [analytics, setAnalytics] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [sessionData, storageData, analyticsData] = await Promise.all([
          api.getSession().catch(() => null),
          api.getStorage().catch(() => null),
          api.getAnalyticsOverview().catch(() => null),
        ]);
        
        if (sessionData?.loggedIn) setSession(sessionData.user);
        setStorage(storageData);
        setAnalytics(analyticsData);
      } catch (error) {
        console.error("Error fetching profile data", error);
      }
    };
    fetchData();
  }, []);

  return (
    <div className="flex w-full flex-col gap-5">
      <div className="w-ful mt-3 flex h-fit flex-col gap-5 lg:grid lg:grid-cols-12">
        <div className="col-span-4 lg:!mb-0">
          <Banner session={session} analytics={analytics} onUpdate={setSession} />
        </div>

        <div className="col-span-3 lg:!mb-0">
          <Storage storage={storage} />
        </div>

        <div className="z-0 col-span-5 lg:!mb-0">
          <Upload onUpdate={setSession} />
        </div>
      </div>
      {/* all project & ... */}

      <div className="grid h-full grid-cols-1 gap-5 lg:!grid-cols-12">
        <div className="col-span-12 lg:mb-0">
          <EditProfile session={session} onUpdate={setSession} />
        </div>
      </div>
    </div>
  );
};

export default ProfileOverview;
